import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {RouterModule} from "@angular/router";
import {NavigationComponent} from "./navigation.component";
import {UsersService} from "../../../models/users/users.service";
import {CompaniesService} from "../../../models/companies/companies.service";
import {Roles} from "../../../models/roles";
import {SocketService} from "../../../models/socket/socket.service";
import {NotificationsService} from "../../../models/notifications/notifications.service";
import {BadgesService} from "../../../models/badges/badges.service";
import {PermissionsService} from "../../../services/permissions/permissions.service";

@NgModule({
    declarations: [NavigationComponent],
    imports     : [BrowserModule, RouterModule],
    exports     : [NavigationComponent],
    providers: [
        UsersService,
        CompaniesService,
        Roles,
        SocketService,
        NotificationsService,
        BadgesService,
        PermissionsService
    ]
})

export class NavigationModule {}


// WEBPACK FOOTER //
// ./src/app/components/common/navigation/navigation.module.ts